import { useSelector } from "react-redux";
import useLayoutPresets, { LayoutPreset } from "./useLayoutPresets";
import { useMemo } from "react";
import { CursorType } from "@/store/globalSettingsSlice";
import useTypographyPresets from "./useTypographyPresets";
import { useCodebaseStore } from "@/store/zustand/codebaseStore";

export const useLayoutAndTypography = () => {
  const selectedLayoutOption = useSelector(
    (state: any) => state.globalSettings.selectedLayoutOption,
  );
  const { options: layoutOptions } = useLayoutPresets();
  const selectedLayoutOptionToUse: LayoutPreset = useMemo(() => {
    return selectedLayoutOption || layoutOptions[0];
  }, [selectedLayoutOption, layoutOptions]);

  const { options: typographyOptions, defaultOption: defaultTypography } =
    useTypographyPresets();
  const selectedTypographyOption = useSelector(
    (state: any) => state.globalSettings.selectedTypographyOption,
  );
  const selectedTypographyOptionToUse = useMemo(() => {
    return (
      selectedTypographyOption || typographyOptions[0] || defaultTypography
    );
  }, [selectedTypographyOption, typographyOptions, defaultTypography]);

  const conditions = useCodebaseStore((state) => state.conditions);
  const usingTailwind = conditions && conditions["tailwindInstalled"]?.met;

  return {
    selectedLayoutOptionToUse,
    selectedTypographyOptionToUse,
    usingTailwind,
  };
};
